import { MapUiTheme } from '../../common';
import { margin } from '../../common/theme/utils';

export const hintTheme = {
  defaultStyles: {
    ...margin((theme: MapUiTheme) => theme.spacing['3'], 0),
  },
  isInvalid: {
    color: (theme: MapUiTheme) => theme.colors.danger300,
  },
  isCompleted: {
    color: (theme: MapUiTheme) => theme.colors.success300,
  },
  isDisabled: {
    color: (theme: MapUiTheme) => theme.colors.grey300,
  },
  isVerified: {
    color: (theme: MapUiTheme) => theme.colors.success300,
  },
};
